function SelectedCtrl (companyFactory) {
  const vm = this;
  const checkbox = companyFactory.checkbox;

  vm.uncheck = function () {
    checkbox.check(vm.node, 'unchecked');
  };

  pnTopbar.onChangeLanguage = function (language) {
    vm.language = language; // dynamically update language
  };

  pnTopbar.onChangeMarket = function (market) {
    vm.market = market; // dynamically update market
  };

  vm.language = pnTopbar.language;
  vm.market = pnTopbar.market;
}

angular.module('web2print.recipients')
  .controller('selectedCtrl', SelectedCtrl);

SelectedCtrl.$inject = ['companyFactory'];
